module.exports = __webpack_public_path__ + "img/Shower&NewBaby.51a676dd.png";